module.exports = __webpack_public_path__ + "images/wheatyellowrust_f32b9051722c679823565fb850bd81df.jpg";